import ReactDOM from 'react-dom/client'
import { RouterProvider, createRouter } from '@tanstack/react-router'
import { routeTree } from './routeTree.gen'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'

const queryClient = new QueryClient();
const basepath = __BASE_PATH__

const router = createRouter({
  routeTree,
  basepath,
  defaultPreload: 'intent',
  scrollRestoration: true,
  context: {
        queryClient,
    },
})

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }

  // Pagination position lives in history state (not the URL) so browser
  // back/forward restores it within a session, while shared/cold links fall
  // back to page 1. `cursor`, `page`, and `direction` are written together so
  // the displayed page number can never drift from the data the cursor fetched.
  // `direction` is required because Confluence's cursor is ambiguous on its own
  // and needs &next=true / &prev=true to know which way to read from it.
  interface HistoryState {
    cursor?: string
    page?: number
    direction?: 'next' | 'prev'
  }
}

const rootElement = document.getElementById('app')!

if (!rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement)
  root.render(
      <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
      </QueryClientProvider>
  )
}
